import { NodeType } from '@/enums/node-type.enum';
import { DEFAULT_NODE_WIDTH } from '@/consts/node-ui.consts';
import type { PackUnpackItem } from './packUnpack.consts';
import type { Node, ImportData } from '@/types/node';

export { getIteratorInfo, getImportNodeFileType } from './utils/nodeUtils';
export type { IteratorInfo } from './utils/nodeUtils';

export function getRightmostX(nodes: Node[]): number {
  return Math.max(...nodes.map((n) => n.position.x + (n.width ?? DEFAULT_NODE_WIDTH)));
}

export function getAverageY(nodes: Node[]): number {
  const sum = nodes.reduce((acc, n) => acc + n.position.y, 0);
  return sum / nodes.length;
}

export function nodesToPackUnpackItems(nodes: Node[]): PackUnpackItem[] {
  const allImport = nodes.every((n) => n.type === NodeType.Import);
  if (allImport) {
    return nodes.flatMap((n) =>
      ((n.data as ImportData).files ?? []).map((file): PackUnpackItem => ({ type: 'file', file })),
    );
  }

  const allPrompt = nodes.every((n) => n.type === NodeType.PromptV3 || n.type === NodeType.Prompt);
  if (allPrompt) {
    return nodes
      .map((n) => (n.data as { prompt?: string }).prompt ?? '')
      .filter((t) => t.length > 0)
      .map((text): PackUnpackItem => ({ type: 'text', text }));
  }

  return [];
}
